import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    component: () => import('../views/home/index.vue')
  },
  {
    path: '/product-info',
    component: () => import('../views/product-info.vue')
  },
  {
    path: '/payment',
    component: () => import('../views/payment.vue')
  },
  {
    path: '/order',
    component: () => import('../views/order/order.vue')
  },
  // {
  //   path: '/renew',
  //   component: () => import('../views/renew.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
